import { useEffect, useState } from "react";
import { getTranslation } from "../../../Utils/Converters";
import { SourceDto } from "../../../Types/ApiTypes";
import SourceModal from "./SourceModal";
import { deleteSource } from "../../../Utils/LocalApi";

interface SourceListItemComponentProps{
    source: SourceDto,
    deleteSource: (id?: number)=> void
}


const SourceListItemComponent = (props: SourceListItemComponentProps)=>{
    const [source, setSource] = useState({} as SourceDto);
    const [isModalOpen, setIsModalOpen] = useState(false);
    useEffect(() => {
        setSource(props.source);
    },[props.source])

    return(
        <>
            <tr>
                <td>{source.id}</td>
                <td className="text-start">{source.name ? getTranslation(source.name) : ""}</td>
                <td>{source.year > 0 ? source.year : ""}</td>
                <td>{source.code ? source.code : ""}</td>
                <td>
                    <span role="button"
                        onClick={(e => {
                            setIsModalOpen(true);
                        })}
                    >
                        <i className="bi bi-pencil-square"></i>
                    </span>
                    &nbsp;
                    <span role="button"
                        onClick={(e => {
                            let id = props.source.id;
                            if (id) {
                                deleteSource(id).then((result) => {
                                    if (result >= 200 && result < 300){
                                        props.deleteSource(id)
                                    }
                                });
                            }
                        })}
                    >
                        <i className="bi bi-trash"></i>
                    </span>
                    {isModalOpen && 
                    <SourceModal
                        source={source}
                        updateSource={setSource}
                        deleteSource={(id?: number)=>{props.deleteSource(id)}}
                        closeModal={()=>{setIsModalOpen(false)}}
                    />}
                </td>
            </tr>
        </>
    )
}
export default SourceListItemComponent;